module.exports = __webpack_public_path__ + "static/media/cloud-update.5ca20617.svg";